module.exports = __webpack_public_path__ + "img/Logo-martinez-horizontal-blanco.eb478e23.png";